module.exports = __webpack_public_path__ + "img/customer-chat.82d0c5e.png";